/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var CoursesIcon = createIcon("CoursesIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 16c0 1.657-3.582 3-8 3s-8-1.343-8-3V9h16v7Z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.45 3.6 23.7 8.55c.4.2.4.75 0 .95l-11.25 4.95c-.3.1-.6.1-.9 0L.3 9.5c-.4-.2-.4-.75 0-.95L11.55 3.6c.3-.15.6-.15.9 0Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.447 18.322A.999.999 0 003 17.134V10.6L12.6 9c.25-.05.45-.35.4-.6-.05-.25-.35-.45-.6-.4l-10 1.7c-.2.05-.4.25-.4.5v6.934a1 1 0 00-.447 1.188A1.49 1.49 0 001 19.5c0 .85 1.5 3 1.5 3s1.5-2.15 1.5-3c0-.486-.212-.906-.553-1.178Z",
    fill: "#4D4D4D"
  })));
}, {});